
import {View} from 'backbone';
import template from 'dashboard/connections/action-general.ejs'
import $ from 'jquery';
import constants from 'Constants';

class ActionGeneralView extends View {
    initialize(opts){

        this.template = template;
        this.actionService = opts.actionService;

        this.events = {
            'focusout input[name=_name]':'changeActionNameAndType',
            'change select[name=_type]':'changeActionNameAndType',
            'change input[name=_active]':'changeActionStatus',
            'change select[name="permissions"]':'updatePermissions',
            'click #addPermission': 'addPermission',
            'click #removePermission': 'removePermission'
        };

        this.actionService.addDefaultParameters();

        this.listenTo(this.model, 'change', this.render);


        return this;
    }

    changeActionNameAndType(event){
        if (event.target.name === '_type' && event.target.value === constants.CONNECTION_WEB_SERVICES_XML_RESULT) {
            let currentActionDetails = this.model.get('currentActionDetails');
            currentActionDetails.ActionXML.Action.Receive.Parameter = [];
            this.model.set('currentActionDetails', currentActionDetails, { silent: true });
        }

        return this.actionService.changeActionNameAndType.apply(this.actionService, arguments);
    }

    changeActionStatus(){
        return this.actionService.changeActionStatus.apply(this.actionService, arguments);
    }

    updatePermissions(){
        return this.actionService.updatePermissions.apply(this.actionService, arguments);
    }

    addPermission() {
        return this.actionService.addPermission.apply(this.actionService, arguments);
    }

    removePermission() {
        return this.actionService.removePermission.apply(this.actionService, arguments);
    }



    updateModelPermission(){
        // First Grabbing the Current Model And the Currently Selected Permission.
        let currentModel=this.model.get('currentActionDetails'),
            currentSelection=this.model.get('selectedPermission');

        // Grabbing the current User from the model to modify its permissions.
        let selectedUserIndex=currentModel.PermissionsXML.map((user=>{
            return user['@caption'];
        })).indexOf(currentSelection);
        let user=currentModel.PermissionsXML[selectedUserIndex];
        user.Permission=[];
        $('#permissionTypes input[type=checkbox]:checked').each(function(){
            let elem=$(this);
            switch (elem.attr('id')){
                case 'useAllow':user.Permission.push({ '#text':'allow','@type':'report'});
                    break;
                case 'useDeny':user.Permission.push({ '#text':'deny','@type':'report'});
                    break;
                case 'editAllow':user.Permission.push({ '#text':'allow','@type':'edit'});
                    break;
                case 'editDeny':user.Permission.push({ '#text':'deny','@type':'edit'});
                    break;
                case 'fullAllow':user.Permission=[];
                    user.Permission.push({ '#text':'allow','@type':'report'});
                    user.Permission.push({ '#text':'allow','@type':'edit'});
                    user.Permission.push({ '#text':'allow','@type':'administer'});
                    break;
                case 'fullDeny':user.Permission=[];
                    user.Permission.push({ '#text':'deny','@type':'report'});
                    user.Permission.push({ '#text':'deny','@type':'edit'});
                    user.Permission.push({ '#text':'deny','@type':'administer'});
                    break;
            }
        });
        currentModel.PermissionsXML[selectedUserIndex]=user;
        this.model.set('currentActionDetails',currentModel,{silent:true});
        this.model.set('hasChanges', true, {silent:true});
        this.model.trigger('change');

        $('#removePermission').attr('disabled', false);
    }

    hookupPermissionEvents(){
        $('#useAllow').on('change',(event)=>{
            if(event.currentTarget.checked) {
                $('#useDeny').prop('checked', false);
            }
            this.updateModelPermission()

        });
        $('#useDeny').on('change',()=>{
            if(event.currentTarget.checked) {
                $('#useAllow').prop('checked', false);
            }
            this.updateModelPermission()
        });
        $('#editAllow').on('change',()=>{
            if(event.currentTarget.checked) {
                $('#editDeny').prop('checked', false);
            }
            this.updateModelPermission()
        });
        $('#editDeny').on('change',()=>{
            if(event.currentTarget.checked) {
                $('#editAllow').prop('checked', false);
            }
            this.updateModelPermission();
        });

        $('#fullAllow').on('change',()=>{
            if(event.currentTarget.checked) {
                $('#useDeny').prop('checked', false);
                $('#editDeny').prop('checked', false);
                $('#fullDeny').prop('checked', false);

                $('#useAllow').prop('checked', true);
                $('#editAllow').prop('checked', true);
            }
            this.updateModelPermission();
        });
        $('#fullDeny').on('change',()=>{
            if(event.currentTarget.checked) {
                $('#useAllow').prop('checked', false);
                $('#editAllow').prop('checked', false);
                $('#fullAllow').prop('checked', false);

                $('#useDeny').prop('checked', true);
                $('#editDeny').prop('checked', true);
            }
            this.updateModelPermission();
        });
    }

    renderPermissionOptions(){
        let currentModel=this.model.get('currentActionDetails'),
            currentSelection=this.model.get('selectedPermission');

        if(!currentSelection){
            $("#permissionTypes input[type='checkbox']").prop('disabled',true);
            return;
        }
        $("#permissionTypes input[type='checkbox']").prop('disabled',false);
        $(`option[value="${currentSelection}"]`).prop('selected',true);
        let selectedUserIndex=currentModel.PermissionsXML.map((user=>{
            return user['@caption'];
        })).indexOf(currentSelection);
        if (selectedUserIndex > -1) {
            let user = currentModel.PermissionsXML[selectedUserIndex];
            if (user.Permission) {
                user.Permission.forEach((permission) => {
                    switch (permission['@type']) {
                        case 'report':
                            if (permission['#text'] === 'allow') {
                                $('#useAllow').prop('checked', true).prop('disabled', false);
                            }
                            else {
                                $('#useDeny').prop('checked', true).prop('disabled', false);
                            }
                            break;
                        case 'edit':
                            if (permission['#text'] === 'allow') {
                                $('#editAllow').prop('checked', true).prop('disabled', false);
                            }
                            else {
                                $('#editDeny').prop('checked', true).prop('disabled', false);
                            }
                            break;
                        case 'administer':
                            if (permission['#text'] === 'allow') {
                                $('#useDeny').prop('checked', false).prop('disabled', true);
                                $('#editDeny').prop('checked', false).prop('disabled', true);
                                $('#fullDeny').prop('checked', false).prop('disabled', false);
                                $('#useAllow').prop('checked', true).prop('disabled', true);
                                $('#editAllow').prop('checked', true).prop('disabled', true);
                                $('#fullAllow').prop('checked', true).prop('disabled', false);
                            }
                            else {
                                $('#useAllow').prop('checked', false).prop('disabled', true);
                                $('#editAllow').prop('checked', false).prop('disabled', true);
                                $('#fullAllow').prop('checked', false).prop('disabled', false);
                                $('#useDeny').prop('checked', true).prop('disabled', true);
                                $('#editDeny').prop('checked', true).prop('disabled', true);
                                $('#fullDeny').prop('checked', true).prop('disabled', false);
                            }
                            break;
                    }
                });
            }
        }
    }



    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const currentModel=this.model.get('currentActionDetails');

        this.$el.css('cursor', 'default');

        // Cleaning select options first.
        $(`select[name='permissions']`).empty();
        // Filling Permission Dropdown with the data from the API after rendering.
        if (currentModel.PermissionsXML) {
            for (let permission of currentModel.PermissionsXML) {
                $(`select[name='permissions']`).append($("<option></option>")
                    .attr('value', permission['@caption'])
                    .text(permission['@caption']));
            }
        }

        $(`option[value=${currentModel.Type}]`).prop('selected',true);

        this.hookupPermissionEvents();

        this.renderPermissionOptions();

        if(currentModel.IsActive === 'false'){
            $('#permissionTypes').addClass('hide');
        }

        $('input[name="_name"]').on("focus").val("").val(this.model.get('currentActionDetails').Name);


        this.delegateEvents();
        return this;
    }

}

export default ActionGeneralView;